export default __webpack_public_path__ + "static/invitato-ede8ff4d8a59eb82befec0ec2f433704.png";